var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSortingi = function SvgSortingi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M19.45 13.12a2.13 2.13 0 0 0-2.66 0l-2.9 2.46v-11A1.75 1.75 0 0 0 12 3a1.75 1.75 0 0 0-1.88 1.59v10.99l-2.9-2.46a2.13 2.13 0 0 0-2.66 0 1.42 1.42 0 0 0 0 2.25l6.11 5.16a2 2 0 0 0 .61.34 2.16 2.16 0 0 0 1.44 0 2 2 0 0 0 .61-.34l6.12-5.16a1.42 1.42 0 0 0 0-2.25"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSortingi);
export default ForwardRef;